import React from 'react';
import { useSelector } from 'react-redux';
import welcomeImagePath from '../../../../assets/images/welcome-image.png';
import './index.scss';

const WelcomeSection = () => {
    const insurancePage = useSelector((store) => store.insurancePage);

    return (
        <section className="welcome-section">
            <div className="welcome-top-container">
                <img src={welcomeImagePath} alt="Welcome Image" className="welcome-image" />

            </div>

            <div className="welcome-bottom-container">
                <h1 className="welcome-title">
                    {insurancePage?.general?.main_title}
                </h1>

                <p className="welcome-paragraph">
                    {insurancePage?.general?.main_description}
                </p>
            </div>
        </section>
    );
};

export default WelcomeSection;
